import { LidProvider } from './../../../../providers/lid-provider/lid-provider';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, Platform, ToastController } from 'ionic-angular';
import { ActivityService, PARTNER_PROVIDERS } from '../../../../providers/activities.service';
import { TranslateService } from '@ngx-translate/core';
import { ResultProvider } from '../../../../providers/result/result';
import { SettingsProvider } from '../../../../providers/settings/settings';
import { GpsTracker } from '../../../../tracker/gps-tracker';
import { TrackingService } from '../../../../providers/tracking.service';
import { CategoriesProvider } from '../../../../providers/categories/categories';
import { SessionProvider } from '../../../../providers/session/session';
var tcx = require("tcx-js")

@Component({
  selector: 'component-activity-import',
  templateUrl: 'activity-import.html'
})
export class ActivityImportComponent implements OnInit {

  @Input("instance") parent;
  httpCounter: number = 0;

  isAuthorized = {
    strava: false,
    polar: false,
    garmin: false,
    fitbit: false
  };

  categories = {
    en: [],
    de: []
  };

  lang: string = "de";
  

  constructor(
    private inAppBrowser: InAppBrowser,
    private platform: Platform,
    private lidProvider: LidProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private activityService: ActivityService,
    private resultService: ResultProvider,
    private settingsService: SettingsProvider,
    private categoriesService: CategoriesProvider,
    private trackingService: TrackingService,
    private sessionService: SessionProvider
  ) { }

  ngOnInit(): void {
    this.settingsService.getActiveLanguage().then(lang => this.lang = lang);
    // Promise.all([this.categoriesService.getCategoriesByLang("en"), this.categoriesService.getCategoriesByLang("de")]).then((values) => {
      // this.categories.en = values[0];
      // this.categories.de = values[1];
      this.updateAuthStatus();
    // });
  }

  run(requestAuth: boolean = true, partner = PARTNER_PROVIDERS.STRAVA) {
    this.lidProvider.getLidByToken().then(lid => {
      this.requestAccessData(lid, partner).then(accessData => {
        if (accessData) {
          this.sessionService.getToken().then(token => {
            this.requestActivities(lid, partner).then((routes: any) => {
              console.log('request activities')
              let index = 0;
              const interval = setInterval(() => {
                if (index < routes.length) {
                  // this.resultService.saveRoute(token, routes[index]).then(() => {
                    // console.log('the route is saved...');
                  // }).catch(err => {
                    // console.log('the error while saving the route...', err);
                  // })
                  index++;
                } else {
                  clearInterval(interval); 
                }
              }, 300);
              this.parent.tab = "activity";
            });
          })
        } else if (requestAuth) {
          this.requestAuthorization(lid, partner);
        }else if(accessData == null){
        }
      });
    })
  }

  updateAuthStatus() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.lidProvider.getLidByToken().then(lid => {
      Promise.all([
        this.requestAccessData(lid, PARTNER_PROVIDERS.STRAVA),
        this.requestAccessData(lid, PARTNER_PROVIDERS.POLAR),
        this.requestAccessData(lid, PARTNER_PROVIDERS.GARMIN),
        this.requestAccessData(lid, PARTNER_PROVIDERS.FITBIT),
      ]).then(() => {
        loader.dismiss();
      }).catch((err) => {
        loader.dismiss();
        console.error(err);
      });
    });
  }

  /*
  * The general auth method 
  * @param lid
  * @param partner: default is STRAVA 
  */
  requestAuthorization(lid, partner) {
    return new Promise((resolve, reject) => {
      switch (partner) {
        case PARTNER_PROVIDERS.STRAVA: {
          this.requestStravaAuthorization(lid).then(() => resolve(true));
          break;
        }
        case PARTNER_PROVIDERS.POLAR: {
          this.requestPolarAuthorization(lid).then(() => resolve(true))
          break;
        }
        case PARTNER_PROVIDERS.GARMIN: {
          this.requestGarminAuthorization(lid).then(() => resolve(true))
          break;
        }
        case PARTNER_PROVIDERS.FITBIT: {
          this.requestFitbitAuthorization(lid).then(() => resolve(true))
          break;
        }
      }
    });
  }
  requestStravaAuthorization(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestStravaAuthorization(lid).then((url) => {
        if (this.platform.is('cordova')) {
          const browser = this.inAppBrowser.create(url, "_blank", { hardwareback: 'yes' });
          browser.show();
          browser.on('exit').subscribe(() => {
            this.run(false, PARTNER_PROVIDERS.STRAVA);
          });
        } else {
          let auth_dialog = window.open(url);
          var interval = setInterval(() => {
            if (auth_dialog.closed) {
              clearInterval(interval);
              this.run(false, PARTNER_PROVIDERS.STRAVA);
            }
          }, 1000);
        }
      });
    })
  }
  requestPolarAuthorization(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestPolarAuthorization(lid).then((url) => {
        if (this.platform.is('cordova')) {
          const browser = this.inAppBrowser.create(url, "_blank", { hardwareback: 'yes' });
          browser.show();
          browser.on('exit').subscribe(() => {
            this.run(false, PARTNER_PROVIDERS.POLAR);
          });
        } else {
          let auth_dialog = window.open(url);
          var interval = setInterval(() => {
            if (auth_dialog.closed) {
              clearInterval(interval);
              this.run(false, PARTNER_PROVIDERS.POLAR);
            }
          }, 1000);
        }
      });
    })
  }
  requestGarminAuthorization(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestGarminAuthorization(lid).then((url) => {
        if (this.platform.is('cordova')) {
          const browser = this.inAppBrowser.create(url, "_blank", { hardwareback: 'yes' });
          browser.show();
          browser.on('exit').subscribe(() => {
            this.run(false, PARTNER_PROVIDERS.GARMIN);
          });
        } else {
          let auth_dialog = window.open(url);
          var interval = setInterval(() => {
            if (auth_dialog.closed) {
              clearInterval(interval);
              this.run(false, PARTNER_PROVIDERS.GARMIN);
            }
          }, 1000);
        }
      });
    })
  }
  requestFitbitAuthorization(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestFitbitAuthorization(lid).then((url) => {
        if (this.platform.is('cordova')) {
          const browser = this.inAppBrowser.create(url, "_blank", { hardwareback: 'yes' });
          browser.show();
          browser.on('exit').subscribe(() => {
            this.run(false, PARTNER_PROVIDERS.FITBIT);
          });
        } else {
          let auth_dialog = window.open(url);
          var interval = setInterval(() => {
            if (auth_dialog.closed) {
              clearInterval(interval);
              this.run(false, PARTNER_PROVIDERS.FITBIT);
            }
          }, 1000);
        }
      });
    })
  }

  /**
   * the general request activity method
   * @param lid 
   * @param partner 
   * @returns 
   */
  requestActivities(lid, partner) {
    let loader = this.loadingCtrl.create({});
    loader.present();
    return new Promise((resolve, reject) => {
      switch (partner) {
        case PARTNER_PROVIDERS.STRAVA: {
          this.requestStravaActivities(lid).then((routes) => {
            loader.dismiss();
            resolve(routes);
          }).catch(() => {
            this.showMessage('Strava');
            loader.dismiss();
          });
          break;
        }
        case PARTNER_PROVIDERS.POLAR: {
          this.requestPolarActivities(lid).then((routes) => {
            loader.dismiss();
            resolve(routes);
          }).catch(() => {
            this.showMessage('Polar');
            loader.dismiss();
          });
          break;
        }
        case PARTNER_PROVIDERS.GARMIN: {
          this.requestGarminActivities(lid).then(() => {
            loader.dismiss();
            resolve(true);
          }).catch(() => {
            this.showMessage('Garmin');
            loader.dismiss();
          });
          break;
        }
        case PARTNER_PROVIDERS.FITBIT: {
          this.requestFitbitActivities(lid).then((routes) => {
            loader.dismiss();
            resolve(routes);
          }).catch(() => {
            this.showMessage('Fitbit');
            loader.dismiss();
          });
          break;
        }
      }
    });
  }

  requestStravaActivities(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestStravaActivityData(lid)
        .then((activities: any[]) => {
          this.httpCounter = 0;
          let routes = [];
          for (let activity of activities) {
            // const route = this.parseStravaActivityToRoute(activity);
            // routes.push(route);
          }
          console.log(routes);
          resolve(routes);
        })
        .catch(err => {
          if (this.httpCounter <= 2) {
            this.requestStravaActivities(lid);
            this.httpCounter += 1;
          } else {
            reject(err)
          }
        });
    })
  }

  requestPolarActivities(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestPolarActivityData(lid)
        .then((activities: any) => {
          this.httpCounter = 0;
          let routes = [];
          for (let activity of activities) {
            // const route = this.parsePolarActivityToRoute(activity);
            // routes.push(route);
          }
          resolve(routes);
        })
        .catch(err => {
          if (this.httpCounter <= 2) {
            this.requestPolarActivities(lid);
            this.httpCounter += 1;
          } else {
            reject(err)
          }
        });
    })
  }

  requestGarminActivities(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestGarminActivityData(lid)
        .then(response => {
          this.httpCounter = 0;
          resolve(response);
        })
        .catch(err => {
          if (this.httpCounter <= 2) {
            this.requestGarminActivities(lid);
            this.httpCounter += 1;
          } else {
            reject(err)
          }
        });
    })
  }

  requestFitbitActivities(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestFitbitActivityData(lid)
        .then((activities: any) => {
          this.httpCounter = 0;
          let routes = [];
          for (let i = 0; i < activities.length; i++) {
            // const route = this.parseFitbitActivityToRoute(activities[i], i);
            // routes.push(route);
          }
          resolve(routes);
        })
        .catch(err => {
          if (this.httpCounter <= 2) {
            this.requestFitbitActivities(lid);
            this.httpCounter += 1;
          } else {
            reject(err)
          }
        });
    })
  }

  requestAccessData(lid: number, partner) {
    return new Promise((resolve, reject) => {
      switch (partner) {
        case PARTNER_PROVIDERS.STRAVA: {
          this.requestStravaAccessData(lid).then(accessData => {
            if (accessData) this.isAuthorized.strava = true;
            resolve(accessData);
          });
          break;
        }
        case PARTNER_PROVIDERS.POLAR: {
          this.requestPolarAccessData(lid).then(accessData => {
            if (accessData) this.isAuthorized.polar = true;
            resolve(accessData);
          });
          break;
        }
        case PARTNER_PROVIDERS.GARMIN: {
          this.requestGarminAccessData(lid).then(accessData => {
            if (accessData) this.isAuthorized.garmin = true;
            resolve(accessData);
          });
          break;
        }
        case PARTNER_PROVIDERS.FITBIT: {
          this.requestFitbitAccessData(lid).then(accessData => {
            if (accessData) this.isAuthorized.fitbit = true;
            resolve(accessData);
          });
          break;
        }
      }
    });
  }

  requestStravaAccessData(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestStravaAccessData(lid)
        .then(accessData => resolve(accessData))
        .catch(err => reject(err));
    });
  }

  requestPolarAccessData(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestPolarAccessData(lid)
        .then(accessData => resolve(accessData))
        .catch(err => reject(err));
    });
  }

  requestGarminAccessData(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestGarminAccessData(lid)
        .then(accessData => resolve(accessData))
        .catch(err => reject(err));
    });
  }
  requestFitbitAccessData(lid: number) {
    return new Promise((resolve, reject) => {
      this.activityService.requestFitbitAccessData(lid)
        .then(accessData => resolve(accessData))
        .catch(err => reject(err));
    });
  }

  connectStrava() {
    this.run(true, PARTNER_PROVIDERS.STRAVA);
  }

  connectPolar() {
    this.run(true, PARTNER_PROVIDERS.POLAR);
  }

  connectGarmin() {
    this.run(true, PARTNER_PROVIDERS.GARMIN);
  }

  connectFitbit() {
    this.run(true, PARTNER_PROVIDERS.FITBIT);
  }

  disconnectStrava() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.lidProvider.getLidByToken().then(lid => {
      this.activityService.disconnectStrava(lid).then(() => {
        this.isAuthorized.strava = false;
        loader.dismissAll()
      }).catch(()=>{
        loader.dismissAll()
      });
    });
  }

  disconnectPolar() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.lidProvider.getLidByToken().then(lid => {
      this.activityService.disconnectPolar(lid).then(() => {
        this.isAuthorized.polar = false;
        loader.dismissAll()
      }).catch(()=>{
        loader.dismissAll()
      });
    });
  }

  disconnectGarmin() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.lidProvider.getLidByToken().then(lid => {
      this.activityService.disconnectGarmin(lid).then(() => {
        this.isAuthorized.garmin = false;
        loader.dismissAll()
      }).catch(()=>{
        loader.dismissAll()
      });
    });
  }

  disconnectFitbit() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.lidProvider.getLidByToken().then(lid => {
      this.activityService.disconnectFitbit(lid).then(() => {
        this.isAuthorized.fitbit = false;
        loader.dismissAll()
      }).catch(()=>{
        loader.dismissAll()
      });
    });
  }


  showMessage(provider: string) {
    let toast = this.toastCtrl.create({
      message: provider + ' ' + this.translate.instant('OAUTH_SERVER_ISSUE')
    });
    toast.present();
  }

  parseStravaActivityToRoute(_activity: any) {
    const activity = JSON.parse(_activity);
    const country = activity.location_country || "";
    let type = activity.sport_type || "";
    const dateTimeFormatted = GpsTracker.formatTime(new Date(activity.start_date), this.settingsService.activeDateFormat, this.translate.getDefaultLang());
    const routeData = JSON.stringify({
      routeInfos: [{
        laps: activity.laps.length,
        path: activity.map.polyline
      }]
    });
    if (this.lang.includes("de")) {
      let index = this.categories.de.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
      if (index >= 0) {
        type = this.categories.de[index];
      } else {
        type = "Sonstige Route";
      }
    } else {
      let index = this.categories.en.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
      if (index >= 0) {
        type = this.categories.en[index];
      } else {
        type = "Other route";
      }
    }
    let emptyRoute = {
      "routeName": activity.name + " " + dateTimeFormatted,
      "images": [],
      "routeData": routeData,
      "routes": [],
      "contents": "",
      "categoryName": type,
      "startCity": activity.location_city,
      "distanceTotal": activity.distance,
      "distanceUnit": "km",
      "lang": this.lang,
      "markers": [],
      "id": -1,
      "cc": country
    };
    return emptyRoute;
  }


  parsePolarActivityToRoute(combinedData: any) {
    const activity = combinedData.activity;
    let type = activity.sport || "";
    // on combinedData.active we don't have start_time of activity
    const dateTimeFormatted = GpsTracker.formatTime(new Date(activity.trackDate), this.settingsService.activeDateFormat, this.translate.getDefaultLang());
    // const dateTimeFormatted = GpsTracker.formatTime(new Date(combinedData.start_time), this.settingsService.activeDateFormat, this.translate.getDefaultLang());

    let routeData
    if(activity.hasroute){
      routeData = JSON.stringify({
        routeInfos: combinedData.routeData.routeInfos
      });
    }
    let timeSec =activity.totalTimeInSeconds;

    // if (this.lang.includes("de")) {
    //   let index = this.categories.de.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
    //   if (index >= 0) {
    //     type = this.categories.de[index];
    //   } else {
    //     type = "Sonstige Route";
    //   }
    // } else {
    //   let index = this.categories.en.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
    //   if (index >= 0) {
    //     type = this.categories.en[index];
    //   } else {
    //     type = "Other route";
    //   }
    // }

    let emptyRoute = {
      "routeName": activity.device + " " + dateTimeFormatted,
      "images": [],
      "routeData": routeData,
      "routes": [],
      "contents": "",
      "categoryName": type,
      "startCity": "",
      "distanceTotal": activity.distanceInMeter,
      "distanceUnit": "km",
      "lang": this.lang,
      "markers": [],
      "id": -1,
      "cc": ""
    };
    return emptyRoute;
  }

  parseFitbitActivityToRoute(combinedData: any, index: number){
    const activity = combinedData.activity;
    let type = activity.activityName || "";
    let activityDate = activity.originalStartTime || activity.trackDate
    const dateTimeFormatted = GpsTracker.formatTime(new Date(activityDate), this.settingsService.activeDateFormat, this.translate.getDefaultLang());

    let routeData, routePoints, routeStrn
    if(activity.hasroute){
      routeData = JSON.stringify({
        routeInfos: combinedData.routeData.routeInfos
      });
      var parser = new tcx.Parser(routeData);
      console.log(parser);
      routePoints = parser.activity.trackpoints.map((point: any) => {
        return {
          lat: point.latitude,
          lng: point.longitude
        }
      });
      const encodedPath = this.trackingService.encodeRoute(routePoints);
      routeStrn = JSON.stringify({
        routeInfos: [{
          path: encodedPath
        }]
      });
    } 
    
    if(this.lang.includes("de")){
      let index = this.categories.de.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
      if (index >= 0) {
        type = this.categories.de[index];
      } else{
        type = "Sonstige Route";
      }
    }else{
      let index = this.categories.en.findIndex(c => c.toLocaleLowerCase().includes(type.toLocaleLowerCase()));
      if (index >= 0) {
        type = this.categories.en[index];
      } else {
        type = "Other route";
      }
    }
 
    let emptyRoute = {
      "routeName": "FitBit " + dateTimeFormatted,
      "images": [],
      "routeData": routeStrn,
      "routes": [],
      "contents": "",
      "categoryName": type || "",
      "startCity": "",
      "distanceTotal": activity.distanceInMeter,
      "distanceUnit": null,
      "lang": this.lang,
      "markers": [],
      "id": -1,
      "cc": ""
    };
    return emptyRoute;
  }

}


// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/activity-import/activity-import.ts